function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-swipeable-views/node_modules/@babel/runtime/helpers/classCallCheck.js
// module id = 2441
// module chunks = 0